export const familyGames = [
  {
    id: "parques-3d",
    name: "Parqués 3D en madera con alcancía",
    tags: ["6+ años", "2–6 jugadores"],
    price: "$310.000",
    description:
      "El parqués de toda la vida, pero en tres dimensiones y con alcancía incorporada. La mesa se llena y nadie se quiere levantar.",
    url: "https://iokus.co/products/parques-3d-x6-alcancia",
    image:
      "https://iokus.co/cdn/shop/files/parques-3d-en-madera-con-alcancia-6-jugadores-2.jpg?v=1776444859&width=1000",
    alt: "Parqués 3D de madera con alcancía, juego de mesa hecho a mano en Colombia por Iokus",
  },
  {
    id: "combo-cartas",
    name: "Combo: Avispa'o + Trucha",
    tags: ["8+ años", "2–6 jugadores"],
    price: "$99.900",
    description:
      "Dos juegos de cartas creados por Iokus. Se aprenden en cinco minutos y las partidas duran lo que dura un café.",
    url: "https://iokus.co/products/combo-juego-de-cartas-avispao-trucha",
    image:
      "https://iokus.co/cdn/shop/files/ComboAvispao_Trucha.jpg?v=1727630783&width=1000",
    alt: "Combo de juegos de cartas Avispa'o y Trucha creados por Iokus",
  },
  {
    id: "bingo-madera",
    name: "Bingo en madera",
    tags: ["Todas las edades", "2–8 jugadores"],
    price: "$210.000",
    description:
      "El clásico que funciona igual con los abuelos que con los nietos. Fichas y balotera en madera trabajada a mano.",
    url: "https://iokus.co/products/juego-de-bingo-en-madera",
    image:
      "https://iokus.co/cdn/shop/files/juego-bingo-de-madera-integracion-familiar.jpg?v=1758312805&width=1000",
    alt: "Bingo en madera con balotera y fichas trabajadas a mano por Iokus",
  },
  {
    id: "tren-mexicano",
    name: "Tren Mexicano — dominó doble 12",
    tags: ["8+ años", "2–8 jugadores"],
    price: "$190.000",
    description:
      "Dominó para mesa grande y tarde larga. Fichas de doble 12 en estuche de madera.",
    url: "https://iokus.co/products/tren-mexicano-domino-doble-12",
    image: "https://iokus.co/cdn/shop/files/domino.jpg?v=1718234656&width=1000",
    alt: "Tren Mexicano, dominó doble 12 de madera en estuche artesanal de Iokus",
  },
  {
    id: "basta-cool",
    name: "Juego de palabras Basta Cool",
    tags: ["8+ años", "2–6 jugadores"],
    price: "$79.900",
    description:
      "Agilidad mental pura: categoría, letra y a correr. El que más risas saca en la mesa.",
    url: "https://iokus.co/products/juego-de-palabras-basta",
    image:
      "https://iokus.co/cdn/shop/files/juego-de-palabras-basta-cool-14.jpg?v=1776354125&width=1000",
    alt: "Juego de palabras Basta Cool con cartas ilustradas de Iokus",
  },
  {
    id: "ay-caramba",
    name: "Ay Caramba",
    tags: ["6+ años", "2–6 jugadores"],
    price: "$190.000",
    description:
      "Juego de puntería y suerte en madera. Fácil de entender, imposible de jugar una sola vez.",
    url: "https://iokus.co/products/ay-caramba",
    image:
      "https://iokus.co/cdn/shop/files/CarambaPNG2.png?v=1719530566&width=1000",
    alt: "Ay Caramba, juego de puntería y suerte en madera de Iokus",
  },
];